<template>
    <Modal
        @close="close"
        title="EMAIL_CHANGE"
        @submit="submit"
        :actions="modalActions"
    >
        <EditSection
            :errors="errors"
            :sections="passwordSections"
            ref="mainSections"
        ></EditSection>
    </Modal>
</template>
<script>
export default {
    data() {
        return {
            errors: new this.$Errors(),
            loading: false,
            passwordSections: {
                old_password: {
                    required: true,
                    title: this.$t('LABEL_PASS'),
                    value: '',
                    type: 'text-input',
                    key: 'old_password',
                    size: 2,
                    password: true
                },
                mail: {
                    required: true,
                    title: this.$t('LABEL_EMAIL'),
                    value: '',
                    type: 'text-input',
                    key: 'mail',
                    size: 2,
                    email: true
                }
            }
        }
    },
    computed: {
        modalActions() {
            return [
                {
                    action: 'submit',
                    display: 'SAVE',
                    loading: this.loading
                }
            ]
        }
    },
    methods: {
        submit() {
            if (this.loading) {
                return
            }
            let data = {}
            if (
                !this.$Utils.setForm(this.passwordSections, data, this.errors)
            ) {
                return
            }
            this.$apiService
                .editAccount(data)
                .then(() => {
                    this.$store.dispatch('resetStore')
                    this.$router.push('/')
                })
                .catch(error => {
                    this.$Network.handleError(error, this.errors)
                })
        },
        close() {
            this.$emit('close')
        }
    }
}
</script>
